import { render } from "./Clinics.vue?vue&type=template&id=09308184&scoped=true&lang=pug"
import script from "./Clinics.vue?vue&type=script&lang=js"
export * from "./Clinics.vue?vue&type=script&lang=js"

import "./Clinics.vue?vue&type=style&index=0&id=09308184&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09308184"]])

export default __exports__